export default __webpack_public_path__ + "static/es-ct-2efc82642b6da0dd1e820230b8d520ba.svg";